module.exports = __webpack_public_path__ + "static/media/garage.f4908c21.svg";